/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_CreateShiftRequest = {
    /**
     * Optional break end time in HH:MM 24-hour format (e.g., "13:00"). Local to the organization's timezone.
     */
    break_end?: string;
    /**
     * Break duration in minutes (subtracted from gross hours to calculate net hours)
     */
    break_minutes?: number;
    /**
     * Optional break start time in HH:MM 24-hour format (e.g., "12:00"). Local to the organization's timezone.
     */
    break_start?: string;
    /**
     * ID of the employee this shift is assigned to. Empty for an open shift (open_shift = true).
     */
    employee_id?: string;
    /**
     * Several employees (#2121): one independent shift or series per employee, written in one transaction, all or nothing unless skip_conflicts. At most 30, unique. Exclusive with employee_id and open_shift; one id behaves exactly like employee_id.
     */
    employee_ids?: Array<string>;
    /**
     * End time in HH:MM 24-hour format (e.g., "16:00"). Local to the organization's timezone. Exclusive boundary for conflict detection.
     */
    end_time: string;
    /**
     * Optional list of group IDs to assign this shift to
     */
    group_ids?: Array<string>;
    /**
     * Optional notes about the shift
     */
    notes?: string;
    /**
     * True creates an OPEN shift without an employee that employees can claim (#2040). It needs at
     * least one group, no recurrence, and employee_id empty.
     */
    open_shift?: boolean;
    /**
     * Recurrence type: NONE (single shift), DAILY (repeat every day), WEEKDAYS (repeat Mon-Fri only), WEEKLY (repeat same weekday), CUSTOM_WEEKDAYS (repeat on a chosen subset of weekdays)
     */
    recurrence_type?: shifts_CreateShiftRequest.recurrence_type;
    /**
     * Number of repetitions for recurring shifts (1-365 for DAILY/WEEKDAYS/CUSTOM_WEEKDAYS, 1-52 for WEEKLY). Required if recurrence_type is not NONE.
     */
    repetitions?: number;
    /**
     * Date of the shift in ISO 8601 format (YYYY-MM-DD), local to the organization's timezone
     */
    shift_date: string;
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    shift_type: shifts_CreateShiftRequest.shift_type;
    /**
     * True creates a recurring shift without the days that overlap another shift of the employee or fall on an approved absence; the response lists them in skipped_dates (#2119). When every day collides the answer is still 409. Ignored for a single shift of one employee; with employee_ids it drops the colliding (employee, day) pairs, and an employee with no free day is listed in skipped and gets nothing (#2121).
     */
    skip_conflicts?: boolean;
    /**
     * Start time in HH:MM 24-hour format (e.g., "08:00"). Local to the organization's timezone.
     */
    start_time: string;
    /**
     * Selected ISO weekdays (1=Mon .. 7=Sun) for CUSTOM_WEEKDAYS recurrence. Required (>=1 value) when recurrence_type is CUSTOM_WEEKDAYS.
     */
    weekdays?: Array<number>;
};
export namespace shifts_CreateShiftRequest {
    /**
     * Recurrence type: NONE (single shift), DAILY (repeat every day), WEEKDAYS (repeat Mon-Fri only), WEEKLY (repeat same weekday), CUSTOM_WEEKDAYS (repeat on a chosen subset of weekdays)
     */
    export enum recurrence_type {
        NONE = 'NONE',
        DAILY = 'DAILY',
        WEEKDAYS = 'WEEKDAYS',
        WEEKLY = 'WEEKLY',
        CUSTOM_WEEKDAYS = 'CUSTOM_WEEKDAYS',
    }
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    export enum shift_type {
        REGULAR = 'REGULAR',
        OVERTIME = 'OVERTIME',
        ON_CALL = 'ON_CALL',
    }
}

